<template>
  <div class="container">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row style="margin-bottom: 15px">
          <a-col :md="7" :sm="7" v-if="handleOptionsData()">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据状态">
              <a-radio-group :default-value="null" :options="typeOptions" @change="onTypeChange" />
            </a-form-item>
          </a-col>
          <a-col :md="17" :sm="17">
            <a-range-picker :default-value="queryParam.stime
              ? [moment(queryParam.stime, 'YYYY-MM-DD HH:mm:ss'), moment(queryParam.etime, 'YYYY-MM-DD HH:mm:ss')]
              : ''
              " style="width: 350px" :showTime="true" format="YYYY-MM-DD HH:mm:ss"
                            :placeholder="['开始时间', '结束时间']"
                            @change="onDateChange" @ok="onDateOk" :allow-clear="false" />
            <a-button type="primary" style="margin-left: 10px" icon="search" @click="searchQuery">查询</a-button>
            <a-button type="primary" style="margin: 0 10px" icon="download" @click="handleExportXls('小时数据.xls')">导出</a-button>
            <a-button @click="openCol" icon="menu-unfold" type="primary" ghost></a-button>
            <a-button v-if="returnState" @click="onToReturn" style="float: right" type="primary"> 返回</a-button>
          </a-col>
        </a-row>
        <col-control ref="colControl" :options="options" @onChange="onChange"></col-control>

        <!--<a-row style="margin: 0 0 10px" v-if="colShow">-->
        <!--<a-col :md="24" :sm="24">-->
        <!--<a-checkbox style="margin-right: 10px" :indeterminate="indeterminate" :checked="checkAll"-->
        <!--@change="onCheckAllChange">-->
        <!--全选-->
        <!--</a-checkbox>-->
        <!--<a-checkbox-group v-model="selectCol" name="checkboxgroup" :options="options"-->
        <!--@change="onChange" />-->
        <!--</a-col>-->
        <!--</a-row>-->
      </a-form>
    </div>
    <div>
      <a-tabs default-active-key="1" @change="onTabChange">
        <a-tab-pane key="1" tab="监测数据">
          <a-table id="tb" ref="table" size="middle" bordered :columns="tableColumns" :scroll="scroll"
                   :dataSource="dataSource"
                   :pagination="ipagination" :loading="loading" @change="handleTableChange">
            <template v-for="slotName in slotNames" v-slot:[slotName]="text, record">
              <slot :name="slotName" :record="record"></slot>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="趋势图">
          <trend ref="trend" :trendObj="trendObj" v-if="tabsKey == 2 && showTab"></trend>
          <a-spin v-else size="large" style="display: flex;justify-content: center;" />
        </a-tab-pane>
      </a-tabs>

      <el-dialog :visible.sync="dialogVisible" :title="dialogTitle + '-详细情况'" v-if="dialogVisible">
        <div style="display: flex; font-size: 15px">
          <span>监测时间: {{ popObj.time }}</span>
          <span style="margin-left: 10%">原始数据: {{ popObj.raw }}</span>
          <span v-if="popObj.zsavg" style="margin-left: 10%">折算均值: {{ popObj.zsavg }}</span>
          <span v-if="popObj.emissionRate" style="margin-left: 10%">排放速率: {{ popObj.emissionRate }}</span>
          <span style="margin-left: 10%" v-show="dialogValue == 3">平台反算结果: {{ popObj.computedResult }}</span>
          <span style="margin-left: 10%" v-show="dialogValue == 3">标识: {{ popObj.match }}</span>
        </div>
        <a-tabs default-active-key="2">
          <!-- <a-tab-pane key="1" tab="关键参数">
          </a-tab-pane> -->
          <a-tab-pane key="2" tab="流程日志">
            <a-radio-group v-model="dialogValue" style="margin-bottom: 10px">
              <a-radio :value="1">
                <span style="color: #000">系统日志</span>
              </a-radio>
              <a-radio :value="2">
                <span style="color: #000">仪器日志</span>
              </a-radio>
              <a-radio :value="3" v-if="parameter.length > 0">
                <span style="color: #000">关键参数</span>
              </a-radio>
            </a-radio-group>
            <a-table :bordered="true" :columns="dialogColumns" :data-source="dialogData" :pagination="false"
                     :scroll="{ y: 360 }">
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'
import { ChangeColMixin } from '@/mixins/ChangeColMixin1'
import { OnlineExportMixin } from '@/mixins/OnlineExportMixin'
import { downloadFile } from '@/api/manage'
import { getAction } from '@/api/manage'
import trend from '@/components/biChart/trend'
import colControl from '@/components/colControl/colControl'
import moment from 'moment'

export default {
  name: 'waterData',
  components: {
    trend,
    colControl
  },
  data() {
    return {
      returnState: false,
      returnSiteId: null,
      returnPath: '',
      dialogValue: 1,
      tabsKey: '',
      tenantId: '',
      showTab: false,
      scroll: {
        y: 540
      },
      dialogVisible: false,
      dialogTitle: '参数详情',
      popObj: {
        value: '',
        time: '',
        raw: '',
        message: '',
        computedResult: '',
        match: '',
        zsavg: '',
        emissionRate: ''
      },
      dialogColumns: [
        {
          title: '监测时间',
          dataIndex: 'dataTime',
          key: 'dataTime',
          align: 'center',
          ellipsis: true,
          width: 150
        },
        {
          title: '日志',
          dataIndex: 'info',
          align: 'center',
          key: 'info',
          ellipsis: true,
          width: 150
        }
      ],
      dialogData: [],
      instrumentLog: [],
      systemLog: [],
      trendObj: {},
      moment,
      parameter: [],
      exportUrl: '',
      exportDataType: '2061',
      ipagination: {
        current: 1,
        pageSize: 12,
        pageSizeOptions: ['12', '24', '48'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      siteType: '',
      typeOptions: [
        {
          label: '生产数据',
          value: 1
        },
        {
          label: '未生产数据',
          value: '2'
        },
        {
          label: '综合数据',
          value: null
        }
      ],
      showSite: true
    }
  },
  created() {
    this.queryParam.st = window.sessionStorage.getItem('siteType')
    this.siteType = window.sessionStorage.getItem('siteType')
    this.$nextTick(() => {
      console.log(this.$route)
      console.log(this.$route.params.year)
    })
    window.sessionStorage.getItem('siteType')
      ? (this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/cn2061')
      : ''
    window.addEventListener('setItem', (e) => {
      if (e.key == 'siteType') {
        this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/cn2061'
      }
    })
    this.exportUrl = this.url + '/export'
    this.queryParam.stime = moment().subtract(1, 'weeks').format('YYYY-MM-DD HH:mm:ss')
    this.queryParam.etime = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss')
    if (this.$route.query && this.$route.query.year) {
      this.queryParam.stime = this.$route.query.year
      this.queryParam.etime = this.$route.query.year
    }
    if (this.$route.query && this.$route.query.path) {
      this.returnState = true
      this.returnSiteId = this.$route.query.selectId ? this.$route.query.selectId : null
      this.returnPath = this.$route.query.path
      this.treeCategory = this.$route.query.category ? this.$route.query.category : null
    }
  },
  mounted() {
    this.popState = true
  },
  mixins: [GetSiteIdMixin, ChangeColMixin, OnlineExportMixin],
  props: ['showSiteTree', 'siteId','otherColumns','slotNames'],
  computed: {
    tableColumns() {
      console.log('columns', this.columns)
      if(this.otherColumns){
        console.log('columns',this.scroll.x)
        console.log('columns',this.columns)
        this.otherColumns.forEach(item=>{
          item.fixed = false
        })
        if(this.scroll.x){
          if(this.columns.some(item=>item.fixed)){
            this.otherColumns.forEach(item=>{
              item.fixed = 'left'
            })
          }
        }else{
          this.columns.forEach(item=>{
            item.fixed = false
          })
        }

        return this.otherColumns.concat(this.columns)
      }else{
        return this.columns
      }
    }
  },
  watch: {
    currentSiteId(value) {
      if (this.showSite) {
        var ids = this.getTreeCurrentId()
        this.queryParam.scopeId = ids[1]
        this.queryParam.scope = ids[0]
        this.queryParam.st = window.sessionStorage.getItem('siteType')
        this.checkAll = true
        this.indeterminate = false
        if (this.url) this.delayLoadData()
        if (window.sessionStorage.getItem('siteType')) {
          this.getCol(window.sessionStorage.getItem('siteType'))
          this.siteType = window.sessionStorage.getItem('siteType')
          if (this.siteType != 31) {
            delete this.queryParam.productionStatus
          } else {
            this.queryParam.productionStatus = this.queryParam.productionStatus ? this.queryParam.productionStatus : null
          }
        }
      }
    },
    siteId: {
      handler(value) {
        this.queryParam.scope = 1
        this.queryParam.scopeId = value
        this.checkAll = true
        this.indeterminate = false
        this.delayLoadData()
        if (window.sessionStorage.getItem('siteType')) {
          this.getCol(window.sessionStorage.getItem('siteType'))
        }
      },
      deep: true,
      immediate: true
    },
    showSiteTree: {
      handler(value) {
        if (value === false) {
          this.showSite = false
        }
      },
      deep: true,
      immediate: true
    },
    dialogValue(value) {
      this.getDialogValue(value)
    },
    loadNum(value) {
      console.log(this.columns)
      console.log(this.options)
      console.log(this.dataSource)

      if (this.options.length > 0) {
        let legendData = []
        let xData = []
        let seriesData = []
        this.options.forEach((item, index) => {
          legendData.push(item.label)
          let newObj = {}
          newObj['name'] = item.label
          newObj['type'] = 'line'
          let arr = []
          this.dataSource.forEach((item1, index1) => {
            if (item1.factor && item1.factor[item.value]) {
              arr.push(item1.factor[item.value].value)
            } else {
              arr.push('')
            }
          })
          newObj['data'] = arr
          seriesData.push(newObj)
        })
        this.dataSource.forEach((item, index) => {
          xData.push(item.dataTime)
        })
        let obj = {
          legendData,
          seriesData,
          xData
        }
        this.trendObj = obj
        this.showTab = true
        console.log(obj)
      }
    }
  },
  methods: {
    onToReturn() {
      console.log('onToReturn', this.returnSiteId)
      console.log('onToReturn', this.returnPath)
      let query = {}
      if (this.returnSiteId) query.selectId = this.returnSiteId
      if (this.treeCategory) query.category = this.treeCategory
      setTimeout(() => {
        this.$router.push({
          path: this.returnPath,
          query
        })
      }, 500)
    },
    getDialogValue(value) {
      if (value == 2) {
        this.dialogData = this.instrumentLog
      } else {
        this.dialogData = this.systemLog
      }

      if (value == 3) {
        this.dialogColumns = [
          {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            ellipsis: true,
            width: 150
          },
          {
            title: '参数值',
            dataIndex: 'value',
            align: 'center',
            key: 'value',
            ellipsis: true,
            width: 150
          },
          {
            title: '备案范围',
            dataIndex: 'range',
            key: 'range',
            align: 'center',
            ellipsis: true,
            width: 150
          },
          {
            title: '是否匹配',
            dataIndex: 'matching',
            align: 'center',
            key: 'matching',
            ellipsis: true,
            width: 150
          }
        ]
        this.dialogData = this.parameter
      } else {
        this.dialogColumns = [
          {
            title: '监测时间',
            dataIndex: 'dataTime',
            key: 'dataTime',
            align: 'center',
            ellipsis: true,
            width: 150
          },
          {
            title: '日志',
            dataIndex: 'info',
            align: 'center',
            key: 'info',
            ellipsis: true,
            width: 150
          }
        ]
      }
    },
    // 弹框
    popUps(code, record, data, codeTitle) {
      console.log('code, record, codeTitle', code, record, codeTitle)
      codeTitle ? (this.dialogTitle = codeTitle) : ''
      let endTime = new Date(new Date(record.dataTime).setHours(new Date(record.dataTime).getHours() + 3))
      let etime = moment(endTime).format('YYYY-MM-DD HH') + ':59:59'
      let params = {
        scope: 1,
        scopeId: this.queryParam.scopeId,
        stime: record.dataTime,
        // stime
        etime,
        factorCode: code
      }
      this.popObj.match = ''
      this.popObj.computedResult = ''
      this.popObj.value = data
      this.popObj.raw =
        record['factor'][code] && record['factor'][code].hasOwnProperty('raw') ? record['factor'][code].raw : ''
      this.popObj.zsavg =
        record['factor'][code] && record['factor'][code].hasOwnProperty('zsavg') ? record['factor'][code].zsavg : ''
      this.popObj.emissionRate =
        record['factor'][code] && record['factor'][code].hasOwnProperty('emissionRate') ? record['factor'][code].emissionRate : ''
      this.popObj.message =
        record['factor'][code] && record['factor'][code].hasOwnProperty('flag')
          ? record['factor'][code].flag.message
          : ''
      this.popObj.time = record.dataTime
      let param = {
        siteId: this.queryParam.scopeId,
        dataTime: record.dataTime,
        factor: code,
        initialValue: this.popObj.raw
      }
      this.systemLog = []
      this.instrumentLog = []
      this.dialogData = []
      this.parameter = []
      this.dialogVisible = true
      getAction('/online/cn3020/queryFactorSite', params).then((res) => {
        console.log('cn3020/queryFactorSite', res)
        if (res.success) {
          if (res.result.hasOwnProperty('systemLog')) {
            this.systemLog = res.result.systemLog
          }
          if (res.result.hasOwnProperty('instrumentLog')) {
            this.instrumentLog = res.result.instrumentLog
          }
        }
        if (this.dialogValue == 1) {
          this.getDialogValue(this.dialogValue)
        } else {
          this.dialogValue = 1
        }
      })
      getAction('/om/parameter/filing/getParameterFilingItems', param).then((res) => {
        console.log('filing/getParameterFilingItem', res)
        if (res.success) {
          this.parameter = res.result
          this.popObj.computedResult = res.result[res.result.length - 1].value
          this.popObj.match = res.result[res.result.length - 1].matching
        }
      })
    },
    onDateChange: function(value, dateString) {
      console.log(dateString[0], dateString[1])
      this.queryParam.stime = dateString[0]
      this.queryParam.etime = dateString[1]
      this.loadData()
    },
    onDateOk(value) {
      console.log(value)
    },
    onTabChange(key) {
      this.tabsKey = key
      this.showTab = false
      if (key == 1) {
        this.searchCount = true
        this.ipagination.pageSize = 12
        this.loadData()
      } else {
        // if(this.queryParam.size == undefined){
        //   this.pageSize = 10
        // }else{
        //   this.pageSize = JSON.parse(JSON.stringify(this.queryParam.size))
        // }
        this.searchCount = false
        this.queryParam.size = -1
        this.trendObj = {
          legendData: [],
          seriesData: [],
          xData: []
        }
        this.loadData()
      }
    },
    onTypeChange(e) {
      this.queryParam.productionStatus = e.target.value
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  padding: 10px 20px 30px;
  box-sizing: border-box;
}

.redText {
  color: red;
  cursor: pointer;
}

.statusText {
  color: #000;
  padding: 3px 10px;
  border-radius: 10px;
}
</style>
